/**
 * Listes d'ingrédients pour l'Assistant Vide-Frigo
 * ~45 lignes
 */

export const commonIngredients = [
  "Poulet",
  "Œufs",
  "Tomate",
  "Oignon",
  "Ail",
  "Riz",
  "Pâtes",
  "Fromage",
  "Lait",
  "Beurre",
  "Bœuf",
  "Porc",
  "Poisson",
  "Saumon",
  "Thon",
  "Crevettes",
  "Bacon",
  "Jambon",
  "Pomme de terre",
  "Carotte",
  "Courgette",
  "Poivron",
  "Champignon",
  "Salade",
  "Farine",
  "Pain",
  "Pomme",
  "Basilic",
  "Persil",
  "Thym",
  "Curry",
  "Sel",
  "Poivre",
  "Sucre",
  "Citron",
  "Huile d'olive",
  "Vinaigre",
  "Moutarde",
];

export const quickStartIngredients = [
  "Poulet",
  "Œufs",
  "Tomate",
  "Riz",
  "Pâtes",
];
